import { mergeAttributes, Node } from '@tiptap/core'

export const ValidatedToolNode = Node.create({
  name: 'validated-tool',
  group: 'block',
  atom: true,
  /* Not node-selectable: this node renders an interactive form (a Braden
   * scale, for one), and clicking inside it to fill it out would otherwise
   * create a ProseMirror NodeSelection — highlighting the whole tool and
   * hijacking the editor's selection, so a stray Backspace could wipe it. It
   * is still removable as a block via a surrounding range selection or
   * Backspace at its edge; only standalone node-selection is disabled. */
  selectable: false,
  addAttributes() {
    /* Each attr needs an explicit parseHTML naming its data attribute. TipTap's
     * default parse reads the attribute under the ATTR's own name (`name`,
     * `response`, `restorationId`), which is not what renderHTML writes, so
     * without these the values render out and never parse back. */
    return {
      name: {
        default: null,
        parseHTML: (element: HTMLElement) => element.getAttribute('data-name'),
        renderHTML: (attributes: Record<string, string>) =>
          attributes.name ? { 'data-name': attributes.name } : {},
      },
      response: {
        default: null,
        parseHTML: (element: HTMLElement) =>
          element.getAttribute('data-response'),
        renderHTML: (attributes: Record<string, string>) =>
          attributes.response ? { 'data-response': attributes.response } : {},
      },
      restorationId: {
        default: null,
        parseHTML: (element: HTMLElement) =>
          element.getAttribute('data-restoration-id'),
        renderHTML: (attributes: Record<string, string>) =>
          attributes.restorationId
            ? { 'data-restoration-id': attributes.restorationId }
            : {},
      },
    }
  },
  parseHTML() {
    return [{ tag: `div[data-type="${this.name}"]` }]
  },
  renderHTML({ HTMLAttributes }) {
    return [
      'div',
      mergeAttributes(HTMLAttributes, {
        'data-type': this.name,
        contentEditable: 'false',
      }),
    ]
  },
})
